import React, { useEffect, useRef } from 'react';
import { useTheme } from '../ThemeContext';

export default function ConfirmDialog({
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Delete',
  confirmStyle,
}) {
  const { colors, common } = useTheme();
  const cancelRef = useRef(null);

  useEffect(() => {
    cancelRef.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div
      style={common.overlay}
      role="dialog"
      aria-modal="true"
      onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}
    >
      <div style={{ ...common.modal, maxWidth: 400 }}>
        <p style={{ color: colors.textPrimary, marginBottom: 24, fontSize: 15, lineHeight: 1.5, margin: '0 0 24px 0' }}>
          {message}
        </p>
        <div style={common.modalActions}>
          <button ref={cancelRef} style={{ ...common.btn, ...common.btnGhost }} onClick={onCancel}>
            Cancel
          </button>
          <button style={{ ...common.btn, ...(confirmStyle || common.btnDanger) }} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
